import "../../../resources/less/Family/ThemePages/SpaghettiWestern.less";
import BaseThematique from "./BaseThematique";

class SpaghettiWestern extends BaseThematique {
  constructor() {
    super();
  }
}

$(window).on("load", () => {
  new SpaghettiWestern();
});
